import Breadcrumb from "components/Common/Breadcrumb2"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import {
  createStatus,
  deleteStatus,
  getAllStatus,
  getStatusSafra,
  restoreStatus,
  updateStatus,
} from "services/shipping-events/calls"

import toast from "components/Toast/Toast"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import Select from "react-select"

const StatusEventos = props => {
  document.title = "Cadastro de Status Safra | Sensetek"
  moment.locale("pt-br")
  const { t } = props

  const [isLoading, setIsLoading] = useState(true)
  const [statuses, setStatuses] = useState()
  const [statusSafra, setStatusSafra] = useState()
  const [novoStatus, setNovoStatus] = useState({
    name: "",
    isLast: false,
    statusSafraId: null,
    type: null,
  })
  const [updatedStatus, setUpdatedStatus] = useState({
    name: "",
    isLast: false,
    statusSafraId: null,
    type: null,
  })

  const [confirm, setConfirm] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [modalUpdateStatus, setModalUpdateStatus] = useState(false)

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const tipoOptions = [
    { label: "Cliente", value: "client" },
    { label: "Fábrica", value: "embossing" },
    { label: "Transportadora", value: "shipping" },
  ]

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: false,
      headerStyle: {
        width: "50px",
      },
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "name",
      text: "Nome",
      sort: false,
    },
    {
      dataField: "type",
      text: "Tipo",
      sort: false,
      formatter: (cellContent, row) => {
        return tipoOptions.find(to => to.value == cellContent)?.label
      },
    },
    {
      dataField: "isLast",
      text: "Finalizador",
      sort: false,
      formatter: (cellContent, row) => (cellContent ? "Sim" : "Não"),
    },
    {
      dataField: "statusSafra.name",
      text: "Status Safra",
      sort: false,
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "Ações",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "10%", textAlign: "center" }
      },
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-primary`}
              onClick={() => {
                setUpdatedStatus({
                  ...row,
                  statusSafraId: statusSafraOptions.find(
                    sso => sso.label == row.statusSafra?.name
                  ),
                  type: tipoOptions.find(to => to.value == row.type),
                })
                setModalUpdateStatus(true)
              }}
            >
              <i
                className="mdi mdi-account-edit"
                id={`altToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`altToolTip${row.id}`}>
              Alterar
            </UncontrolledTooltip>
          </li>
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-${
                row.deletedAt ? "secondary" : "danger"
              }`}
              onClick={async () => {
                if (row.deletedAt) {
                  try {
                    setIsLoading(true)
                    await restoreStatus(row.id)
                    fetchStatusSafra()
                    toast("success", "Status ativado com sucesso!")
                  } catch (error) {
                    toast("warning", "Falha ao ativar Status.")
                    console.log(error)
                  } finally {
                    setIsLoading(false)
                  }
                } else {
                  setConfirm({
                    title: "Confirmação",
                    body: (
                      <div>
                        <p>Esta ação ira desabilitar esta opção de Status.</p>
                        <p>
                          Por favor, confirme se tem certeza que deseja
                          desabilitar este Status?
                        </p>
                      </div>
                    ),
                    onConfirm: async () => {
                      setIsLoading(true)
                      try {
                        await deleteStatus(row.id)
                        fetchStatusSafra()
                        toast("success", "Status desativado com sucesso!")
                      } catch (error) {
                        toast("warning", "Falha ao desativar Status.")
                        console.log(error)
                      } finally {
                        setIsLoading(false)
                      }
                    },
                  })
                  setShowConfirm(true)
                }
              }}
            >
              <i
                className={`mdi mdi-${
                  row.deletedAt ? "account-reactivate" : "delete-forever"
                }`}
                id={`delToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`delToolTip${row.id}`}>
              {`${row.deletedAt ? "Reativar" : "Desativar"}`}
            </UncontrolledTooltip>
          </li>
        </ul>
      ),
    },
  ]

  const fetchStatusSafra = async () => {
    try {
      setIsLoading(true)
      const statuses = await getAllStatus()
      setStatuses(statuses)
      const statusSafra = await getStatusSafra()
      setStatusSafra(statusSafra)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchStatusSafra()
  }, [])

  const statusSafraOptions = statusSafra?.map(s => {
    return { label: s.name, value: s.id }
  })

  const handleSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      if (novoStatus.name) {
        try {
          await createStatus(novoStatus)
          setNovoStatus({
            name: "",
            isLast: false,
            statusSafraId: null,
            type: null,
          })
          fetchStatusSafra()
          toast("success", "Status adicionado com sucesso!")
        } catch (error) {
          console.error(error)
          toast("error", "Falha ao adicionar Status")
        }
      } else {
        toast("warning", "Não é possível adicionar Status com nome vazio.")
      }
    } catch (error) {
      toast("warning", "Falha ao criar Status.")
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleUpdateStatus = async e => {
    e.preventDefault()
    if (updatedStatus.name) {
      try {
        setIsLoading(true)
        await updateStatus(updatedStatus.id, updatedStatus)
        fetchStatusSafra()
        toast("success", "Status atualizado com sucesso!")
      } catch (error) {
        toast("warning", "Falha ao alterar Status.")
        console.log(error)
      } finally {
        setIsLoading(false)
      }
      setModalUpdateStatus(false)
    } else {
      toast("warning", "Não é possível atualizar o nome do Status para vazio.")
    }
  }

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Status"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card className="mb-0">
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  {t("Adicionar")}
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col sm={4}>
                        <FormGroup>
                          <Label>{t("Nome do Status Safra")}</Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Status Safra"
                            disabled={isLoading}
                            value={novoStatus.name}
                            onChange={e => {
                              setNovoStatus(old => {
                                return { ...old, name: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={2}>
                        <FormGroup>
                          <Label>Status Safra</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            options={statusSafraOptions}
                            placeholder="Status Safra"
                            value={novoStatus.statusSafraId}
                            onChange={e => {
                              setNovoStatus(old => {
                                return { ...old, statusSafraId: e }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={2}>
                        <FormGroup>
                          <Label>Tipo</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            options={tipoOptions}
                            placeholder="Tipo"
                            value={novoStatus.type}
                            onChange={e => {
                              setNovoStatus(old => {
                                return { ...old, type: e }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={2}>
                        <br />
                        <br />
                        <FormGroup check>
                          <Input
                            type="checkbox"
                            disabled={isLoading}
                            checked={novoStatus.isLast}
                            onChange={e => {
                              setNovoStatus(old => {
                                return { ...old, isLast: e.target.checked }
                              })
                            }}
                          />{" "}
                          <Label check>Finalizador?</Label>
                        </FormGroup>
                      </Col>
                      <Col className="d-flex align-items-end">
                        <FormGroup>
                          <Button type="submit">{t("Adicionar")}</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Lista de Status
                </CardHeader>
                <CardBody>
                  {!isLoading &&
                    (statuses?.length > 0 ? (
                      <ToolkitProvider
                        keyField="id"
                        columns={columns}
                        columnToggle
                        data={statuses}
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row>
                              <Col xl="12">
                                <BootstrapTable
                                  keyField={"id"}
                                  bordered={true}
                                  striped={true}
                                  condensed
                                  defaultSorted={defaultSorted}
                                  selectRow={selectRow}
                                  classes={"table align-middle table-nowrap"}
                                  headerWrapperClasses={"thead-light"}
                                  {...toolkitProps.baseProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <h5>Nenhum dado foi encontrado.</h5>
                      </div>
                    ))}
                  {isLoading && (
                    <div className="mt-3" style={{ textAlign: "center" }}>
                      <Spinner
                        className="ms-2"
                        style={{ width: "4rem", height: "4rem" }}
                        color="primary"
                      />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={async () => {
              await confirm?.onConfirm()
              setShowConfirm(false)
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={modalUpdateStatus}
        toggle={() => {
          setModalUpdateStatus(!modalUpdateStatus)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>Atualizar Status</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalUpdateStatus(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleUpdateStatus} id="updateStatusSafra">
            <Row>
              <Col>
                <Label>{t("Novo Nome")}</Label>
                <Input
                  type="text"
                  className="form-control"
                  disabled={isLoading}
                  value={updatedStatus.name}
                  onChange={e => {
                    setUpdatedStatus(old => {
                      return { ...old, name: e.target.value }
                    })
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <Label>Status Safra</Label>
                <Select
                  classNamePrefix="reactSelect"
                  options={statusSafraOptions}
                  placeholder="Status Safra"
                  value={updatedStatus.statusSafraId}
                  onChange={e => {
                    setUpdatedStatus(old => {
                      return { ...old, statusSafraId: e }
                    })
                  }}
                  styles={{
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  menuPortalTarget={document.body}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <Label>Tipo</Label>
                <Select
                  classNamePrefix="reactSelect"
                  options={tipoOptions}
                  placeholder="Tipo"
                  value={updatedStatus.type}
                  onChange={e => {
                    setUpdatedStatus(old => {
                      return { ...old, type: e }
                    })
                  }}
                  styles={{
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  menuPortalTarget={document.body}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <Input
                  type="checkbox"
                  disabled={isLoading}
                  checked={updatedStatus.isLast}
                  onChange={e => {
                    setUpdatedStatus(old => {
                      return { ...old, isLast: e.target.checked }
                    })
                  }}
                />{" "}
                <Label check>Finalizador?</Label>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setModalUpdateStatus(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="submit"
            form="updateStatusSafra"
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
    </>
  )
}

StatusEventos.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(StatusEventos)
